module.exports = __webpack_public_path__ + "img/gov.170f3079.png";